export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "victory-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "victory-themeWrapLive" */'./LiveThemeImporter'),
  },
};
